import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendPageView } from './pageViews';
import { APPS } from '../utils/cloudStorage';
import { useAuthStore } from '../store/authStore';
import { appForPath, recordToolOpening } from './toolUsage';
export default function RouteAnalytics() {
  const { pathname, key } = useLocation();
  const userId = useAuthStore(state => state.user?._id);
  const navigation = useRef({});
  useEffect(() => {
    const signature = `${pathname}:${key}:${userId || ''}`;
    if (navigation.current.signature !== signature) navigation.current = { signature, id: `${Date.now()}:${Math.random()}` };
    recordToolOpening(appForPath(pathname, APPS), navigation.current.id, userId);
  }, [pathname, key, userId]);
  useEffect(() => {
    // Blog pages report after their asynchronous article data has loaded.
    if (/^\/blog(?:\/|$)/.test(pathname)) return;
    let timer;
    const report = () => { clearTimeout(timer); timer = setTimeout(() => { observer.disconnect(); sendPageView(document.title || 'Devssoft', pathname); }, 250); };
    const observer = new MutationObserver(report);
    observer.observe(document.head, { childList: true, subtree: true, characterData: true });
    report();
    return () => { observer.disconnect(); clearTimeout(timer); };
  }, [pathname, key]);
  return null;
}
